module.exports = __webpack_public_path__ + "static/media/system.27481014.JPG";